/* ============================================================
   LIQUIDSHOP HEADER v2 "COMMAND BAR" — JS vanilla (aucune dépendance)
   Les libellés EN/FR sont rendus côté serveur (Liquid | t) ;
   le toggle EN|FR navigue vers l'URL localisée (/fr prefix).
   ============================================================ */
(function () {
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  var header = $('.header');
  if (!header) return;

  var burger = $('.burger'),
    drawer = $('.menu_second'),
    overlay = $('.overlay'),
    drawerClose = $('.menu_second__close'),
    searchToggle = $('.search-container__toggle'),
    searchForm = $('.search-container__form'),
    searchClose = $('.search-container__close'),
    searchInput = $('.search-container__input'),
    subItem = $('.menu__item--has-sub'),
    subBtn = $('.menu__item--has-sub > .menu__lien'),
    cartLink = $('.header__cart'),
    cartDrawer = $('.cart-drawer'),
    badge = $('[data-cart-badge]');

  /* ---- Langue EN|FR : navigation vers l'URL localisée ---- */
  var isFrench = window.location.pathname === '/fr' || window.location.pathname.indexOf('/fr/') === 0;
  function goLang(l) {
    if ((l === 'fr') === isFrench) return;
    var path = window.location.pathname;
    var newPath;
    if (l === 'fr') {
      newPath = '/fr' + (path === '/' ? '' : path);
    } else {
      newPath = path.replace(/^\/fr(\/|$)/, '/');
    }
    if (!newPath) newPath = '/';
    window.location.href = window.location.origin + newPath + window.location.search + window.location.hash;
  }
  $$('.header__lang-btn').forEach(function (b) {
    b.addEventListener('click', function () { goLang(b.getAttribute('data-lang')); });
  });

  /* ---- Search (barre de commande) ---- */
  function openSearch(focus) {
    header.classList.add('header--search-open');
    searchToggle.setAttribute('aria-expanded', 'true');
    closeSub();
    if (focus !== false) setTimeout(function () { searchInput.focus(); }, 260);
  }
  function closeSearch() {
    header.classList.remove('header--search-open');
    searchToggle.setAttribute('aria-expanded', 'false');
  }
  function searchIsOpen() { return header.classList.contains('header--search-open'); }
  if (searchToggle) {
    searchToggle.addEventListener('click', function () { searchIsOpen() ? closeSearch() : openSearch(); });
    searchClose.addEventListener('click', function () { closeSearch(); searchToggle.focus(); });
    /* raccourci "/" */
    document.addEventListener('keydown', function (e) {
      if (e.key === '/' && !searchIsOpen() && !drawer.classList.contains('is-open')) {
        var t = document.activeElement && document.activeElement.tagName;
        if (t !== 'INPUT' && t !== 'TEXTAREA') { e.preventDefault(); openSearch(); }
      }
    });
  }

  /* ---- Mega-menu (hover = CSS ; clic/tap = toggle) ---- */
  function closeSub() {
    if (!subItem) return;
    subItem.classList.remove('is-open');
    subBtn.setAttribute('aria-expanded', 'false');
  }
  if (subBtn) {
    subBtn.addEventListener('click', function () {
      var open = subItem.classList.toggle('is-open');
      subBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---- Drawer mobile ---- */
  function openDrawer(focus) {
    drawer.classList.add('is-open'); overlay.classList.add('is-open');
    burger.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('is-locked');
    if (focus !== false) drawerClose.focus();
  }
  function closeDrawer(refocus) {
    drawer.classList.remove('is-open'); overlay.classList.remove('is-open');
    burger.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('is-locked');
    if (refocus !== false) burger.focus();
  }
  if (burger && drawer && overlay) {
    burger.addEventListener('click', function () { openDrawer(); });
    drawerClose.addEventListener('click', function () { closeDrawer(); });
    overlay.addEventListener('click', function () { closeDrawer(false); closeCart(false); });
  }

  /* ---- Mini-cart slide-in droite ---- */
  function openCart(focus) {
    cartDrawer.classList.add('is-open'); overlay.classList.add('is-open');
    cartLink.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('is-locked');
    if (focus !== false) {
      var c = $('.cart-drawer__close', cartDrawer); /* re-query : le contenu peut avoir été re-rendu */
      if (c) c.focus();
    }
  }
  function closeCart(refocus) {
    if (!cartDrawer || !cartDrawer.classList.contains('is-open')) return;
    cartDrawer.classList.remove('is-open');
    if (!drawer.classList.contains('is-open')) overlay.classList.remove('is-open');
    cartLink.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('is-locked');
    if (refocus !== false) cartLink.focus();
  }
  if (cartLink && cartDrawer) {
    cartLink.addEventListener('click', function (e) {
      e.preventDefault();
      cartDrawer.classList.contains('is-open') ? closeCart() : openCart();
    });
    /* délégation : le bouton close est remplacé quand le drawer est re-rendu */
    cartDrawer.addEventListener('click', function (e) {
      if (e.target.closest('.cart-drawer__close')) closeCart();
    });
  }

  /* ---- Accordéon Ingredients dans le drawer ---- */
  $$('[data-accordion]').forEach(function (g) {
    var btn = $('.menu_second__lien', g);
    btn.addEventListener('click', function () {
      var open = g.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---- Fermetures globales ---- */
  document.addEventListener('click', function (e) {
    if (subItem && subItem.classList.contains('is-open') && !subItem.contains(e.target)) closeSub();
    if (searchIsOpen() && !searchForm.contains(e.target) && !searchToggle.contains(e.target)) closeSearch();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (cartDrawer && cartDrawer.classList.contains('is-open')) closeCart();
    else if (drawer.classList.contains('is-open')) closeDrawer();
    else if (searchIsOpen()) { closeSearch(); searchToggle.focus(); }
    else if (subItem && subItem.classList.contains('is-open')) closeSub();
  });

  /* ---- Resize vers desktop : ferme le drawer mobile (sinon body reste locké) ---- */
  window.addEventListener('resize', function () {
    if (window.innerWidth > 768 && drawer && drawer.classList.contains('is-open')) closeDrawer(false);
  }, { passive: true });

  /* ---- Sticky : cache au scroll down, revient au scroll up + compact ---- */
  var lastY = window.scrollY || 0;
  window.addEventListener('scroll', function () {
    var y = window.scrollY || 0;
    header.classList.toggle('header--scrolled', y > 24);
    var down = y > lastY;
    if (down && y > 160 && !searchIsOpen() && !header.contains(document.activeElement)) {
      header.classList.add('header--hidden');
    } else if (!down || y <= 160) {
      header.classList.remove('header--hidden');
    }
    lastY = y;
  }, { passive: true });

  /* ---- Badge panier (pour mises à jour AJAX éventuelles) ---- */
  function setCart(n) {
    n = parseInt(n, 10) || 0;
    if (badge) {
      badge.textContent = n > 99 ? '99+' : String(n);
      badge.style.display = n === 0 ? 'none' : 'grid';
    }
    var c = $('[data-cart-count]');
    if (c) c.textContent = '/ ' + (n < 10 ? '0' + n : n);
  }
  /* resynchronise badge + contenu du mini-cart après un add-to-cart AJAX.
     Section Rendering API : re-rend la section header côté serveur et on en
     extrait le drawer frais. Fallback badge-only via /cart.js. Retourne une Promise. */
  function refreshCart() {
    var sid = cartDrawer && cartDrawer.getAttribute('data-section-id');
    if (!sid) {
      return fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { setCart(cart.item_count); })
        .catch(function () {});
    }
    /* préfixe de locale (ex. /fr/) : sans lui, la section serait re-rendue en EN sur les pages FR */
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + '?sections=' + encodeURIComponent(sid))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[sid];
        if (!html) throw new Error('empty section');
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('cart-drawer');
        if (fresh) cartDrawer.innerHTML = fresh.innerHTML;
        var b = doc.querySelector('[data-cart-badge]');
        if (b) setCart(b.textContent);
      })
      .catch(function () {
        /* fallback : au moins le badge */
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { setCart(cart.item_count); })
          .catch(function () {});
      });
  }

  window.LSHeader = {
    openSearch: openSearch, closeSearch: closeSearch,
    openDrawer: openDrawer, closeDrawer: closeDrawer,
    openCart: openCart, closeCart: closeCart,
    setCart: setCart, refreshCart: refreshCart
  };
})();
